import React from 'react'
import { JoinAnd } from '../utils/Join'

import * as AppConstants from '../../utils/constants'

const UpgradeQ = () => {
  return (
    <div>
      <h3 className="font-semibold">Tell me about the 500 sms messages.</h3>

      <p>
        Once a phone number is added to your premium account, notifications from Wandering Labs will be sent by txt
        along with the standard email. This allows for faster notification and maybe grabs your attention more than an
        email.
      </p>

      <p>
        The third party service we use charges on a per message basis, so we must put a limit on how many each person
        can use. Some of our users will never come close to the 500 limit, while others might.
      </p>

      <p>
        If you reach the 500 txt limit, your requests will continue to be checked and you will still be notified by
        email. We offer additional txt packages:{' '}
        <JoinAnd
          items={AppConstants.PRODUCTS.sms.items.map(sms => (
            <span key={sms.count}>
              <span className="font-semibold">{sms.count}</span> for <span className="font-semibold">${sms.value}</span>
            </span>
          ))}
        />
      </p>

      <h3 className="font-semibold">How long does my premium membership last?</h3>

      <p>
        1 Year.
      </p>

      <h3 className="font-semibold">Is this a recurring charge or a subscription?</h3>

      <p>
        No. This is a single payment to become a premium member for the next year. If you are still using Wandering Labs
        after the year is up, we will gently remind you to renew your premium membership.
      </p>

      <h3 className="font-semibold">Unlimited Requests?!?</h3>

      <p>Yes! Our systems are configured to not put any extra undue burden on the third party reservation providers.</p>

      <h3 className="font-semibold">Questions or Comments</h3>

      <p>
        We would be happy to help assist or answer any questions you may have. Send us an email at{' '}
        <a href="mailto:info@wanderinglabs.com">info@wanderinglabs.com</a>
      </p>
    </div>
  )
}

export default UpgradeQ
